<template>
    <div class="bg_content" >
        <div class="toBtnLink" @click="login">
            <div class="login-btn">登录</div>
        </div>
    </div>
</template>
<script>
    import { showLogin } from '../login/login.js'
    export default {
        mounted(){
            document.title = "思谷搜"
        },
        methods: {
             showLogin,
             login(){
                showLogin({
                    show: true
                })
                // console.log("ddddkdkd555555")
                // console.log(this.$route)
                //    this.$router.push({path: "/index"});
                // this.$router.push({ path: "/home" });
                //  this.$router.push("/");
            }
        }
    }
</script>

<style scoped lang="scss">
.bg_content{
    width: 100%;
    height: 1539px;
    background: url(~@/assets/images/bg.jpg) no-repeat center;
    position: relative;
    .toBtnLink{
        position:absolute;
        width: 50%;
        height: 500px;
        top: 400px;
        left: 50%;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        border-radius: 10px;
        transform: translateX(-50%);
    }
    .login-btn{
        width: 200px;
        height:50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 20px;
        border-radius: 10px;
        border: 2px solid #ff8700;
        cursor: pointer;
        background:linear-gradient(to bottom,#ffd34c 0%,#ff9d02 50% ,#ffb701 100%);
    }
}
</style>